import { Row, Col } from 'react-bootstrap'
import PropTypes from 'prop-types'

import ErrorBoundary from '../ErrorBoundary'
import Vote from '~/components/shared/Vote'

import styles from './index.module.scss'

const VotableLayout = ({
  children, className, supportVotes, itemVote, onAuthRequire, onMessageLoad, header, ...props
}) => (
  <ErrorBoundary>
    <Row className={`py-3 border-bottom ${styles.container} ${className}`} noGutters {...props}>
      {!!header && (
        <Col xs={12} className={styles.headerColumn}>
          {header}
        </Col>
      )}
      {supportVotes && (
        <Col xs={{ span: 12, order: 'first' }} md={{ span: 'auto', order: 0 }} className="ml-md-2 mb-2 mr-4">
          <Vote
            item={itemVote}
            onAuthRequire={onAuthRequire}
            onMessageLoad={onMessageLoad}
            className={styles.vote}
          />
        </Col>
      )}
      <Col>
        {children}
      </Col>
    </Row>
  </ErrorBoundary>
)

VotableLayout.propTypes = {
  className: PropTypes.string,
  supportVotes: PropTypes.bool,
  itemVote: PropTypes.object.isRequired,
  onAuthRequire: PropTypes.func.isRequired,
  onMessageLoad: PropTypes.func,
  header: PropTypes.node,
  children: PropTypes.node.isRequired
}

VotableLayout.defaultProps = {
  className: null,
  supportVotes: false,
  onMessageLoad: null,
  header: null
}

export default VotableLayout
